import { Badge } from '@interstate/components/Badge';
import styled from 'styled-components';

type StyledBadgeProps = {
    $isClickable: boolean;
    variant?: string;
};

export const ContractingCustomStyledBadge = styled(Badge)<StyledBadgeProps>`
    cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
    margin-right: 0.7rem;

    ${({ $isClickable }) =>
        $isClickable &&
        `
        &:hover {
            opacity: 0.8;
            background-color: #ebf6ff;
        }
    `}

    ${({ variant }) =>
        variant === 'info' &&
        `
        background-color: #ffffff !important;
        border-color: #005ba8 !important;
        border-width: 1px !important;
        border-style: solid !important;
        color: #005ba8 !important;

        & svg {
            color: #005ba8 !important;
        }
    `}
`;
